export default __webpack_public_path__ + "static/media/home-selected.be78ca8f.svg";